import React, { useState } from 'react';
import last from 'lodash/last';
import { i18n } from '../../translate/i18n';
import ArrowDown from '@mui/icons-material/KeyboardArrowDown';
import ArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Business from '@mui/icons-material/Business';
import Room from '@mui/icons-material/Room';
import { isEmpty } from 'lodash';

import Edit from '@mui/icons-material/Create';
import Add from '@mui/icons-material/Add';
import { useDispatch, useSelector } from "react-redux";
import FileDownloadButton from '../../components/FileDownloadButton/FileDownloadButton';

import * as actions from "../../store/actions";


import {
  StyledTreeNode,
  NodeIcon,
  LeafName,
  BranchName
} from './style'
import hasSiteAccess from '../../utils/hasSiteAccess';
import { Button } from '@mui/material';
import EFeatureFlags from '../../utils/EFeatureFlags';
import { EAccessRole } from '../../store/types';

const TreeNode = (props) => {
  const dispatch = useDispatch();

  const selectedAccess = useSelector(state => state.auth.selectedAccess);
  const copyPlace = useSelector(state => state.places.copyPlace);
  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);
  const isAnalyst = selectedAccess.role === EAccessRole.analyst;
  const isContractor = selectedAccess.role === EAccessRole.contractor;
  const onlyQRServicesFeatureFlag = selectedAccess.tenant.featureFlags.includes(EFeatureFlags.BLOCK_SERVICE_CREATION_WITHOUT_QRCODE_SCANNING);
  const blockQrCodePrinting = (onlyQRServicesFeatureFlag && (isAnalyst || isContractor));
  

  const copyPasteRequest = (pastePlace, siteCopyPart) => dispatch(actions.copyPasteRequest(copyPlace._id, pastePlace, siteCopyPart, selectedSites));

  let { node, getChildNodes, level } = props;
  if (!level) level = 0;

  const tooglePlaces = (node) => dispatch(actions.tooglePlaces(node));

  const [isOptionVisible, setIsOptionVisible] = useState(false);

  const showOptions = () => {
    setIsOptionVisible(true)
  }

  const hideOptions = () => {
    setIsOptionVisible(false)
  }

  const setCopyPlace = () => {
    dispatch(actions.setCopyPlace(node))
  }

  const handlePastePlace = node => {
    copyPasteRequest(node._id, node.site)
  }

  const handleClearCopy = () => {
    dispatch(actions.clearCopyPlace())
  }

  //open = trye or false
  //type = root or branch or leaf
  //edit = true or false
  //parent = the parent node of the creating one (the actulal node you clicked)

  const optionsButtons = (
    <div style={{ display: 'flex', flexDirection: 'row', opacity: node.selectedForCopy ? 0.5 : 1 }}>
      {selectedAccess.role === 'admin' && <Edit onClick={() => props.openModal(true, node.isRoot ? 'root' : node.type, true, node)} style={{ marginLeft: '5px', cursor: 'pointer' }} />}
      {node.type === 'branch' &&
        (
          <>
            {selectedAccess.role === 'admin' && <Add onClick={() => props.openModal(true, 'branch', false, node)} style={{ marginLeft: '5px', cursor: 'pointer' }} />}
            {!blockQrCodePrinting && <FileDownloadButton title={i18n.t('fileDownloadButtonTreeNode.title')} type="place_list_button" documentId={node} />}
            {(!node.isRoot && selectedAccess.role === 'admin' && copyPlace._id !== node._id) && <Button variant='outlined' onClick={() => setCopyPlace()} style={styles.actionButton} color="secondary">{i18n.t('fileDownloadButtonTreeNode.cutOut')}</Button>}
            {(!isEmpty(copyPlace) && !node.selectedForCopy && selectedAccess.role === 'admin') && <Button variant='outlined' onClick={() => handlePastePlace(node)} style={styles.actionButton} color="primary">{i18n.t('fileDownloadButtonTreeNode.paste')}</Button>}
          </>
        )
      }
      {(node.type === 'leaf' && selectedAccess.role === 'admin' && copyPlace._id !== node._id) &&
        <Button variant='outlined' onClick={() => setCopyPlace()} style={styles.actionButton} color="secondary">{i18n.t('btnTreeNode.text')}</Button>
      }
    </div>
  )

  const clickLeaf = (node) => {
    props.history.push(`/admin-equip-places/${node._id}`);
  }

  return <>
    <StyledTreeNode
      level={level}
      type={node.type}
      onMouseEnter={showOptions}
      onMouseLeave={hideOptions}
      selectedForCopy={node.selectedForCopy}
    >
      <div style={{ display: 'flex' }}>
        <NodeIcon selectedForCopy={node.selectedForCopy} onClick={() => tooglePlaces(node)}>
          {node.type === 'branch' && (node.isOpen ? <ArrowDown style={{ cursor: 'pointer' }} /> : <ArrowRight style={{ cursor: 'pointer' }} />)}
        </NodeIcon>

        <NodeIcon selectedForCopy={node.selectedForCopy} marginRight={10}>
          {node.type === 'leaf' && <Room />}
          {node.type === 'branch' && node.isOpen === true && <Business />}
          {node.type === 'branch' && !node.isOpen && <Business />}
        </NodeIcon>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: node.highlight && 'yellow' }}>
          {node.type === 'leaf' ?
            <LeafName selectedForCopy={node.selectedForCopy} title={i18n.t('leafNametreeNode.title')} onClick={() => clickLeaf(node)}>{node.name}</LeafName> :
            <BranchName selectedForCopy={node.selectedForCopy}>{node.name}</BranchName>
          }
          <div style={{ marginLeft: '10px' }}>{(isOptionVisible && hasSiteAccess(selectedAccess, node.site)) && optionsButtons}</div>

        </div>
      </div>
      {copyPlace._id === node._id &&
        <Button
          variant='outlined'
          onClick={() => handleClearCopy()}
          style={styles.actionButton}>{i18n.t('btnTreeNode.cancel')}</Button>
      }

    </StyledTreeNode>
    {node.isOpen && getChildNodes(node).map(childNode => (
      <TreeNode
        {...props}
        key={childNode._id}
        node={childNode}
        level={level + 1}
      />
    ))}
  </>;

}

const styles = {
  actionButton: {
    marginLeft: 5,
    cursor: 'pointer',
    fontSize: 11,
    padding: '2px 5px',


  }
}

export default TreeNode;
